(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["td-bundle-overrides"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('td-bundle-overrides')) {
  customElements.define('td-bundle-overrides', class extends HTMLElement {
    constructor() {
      super();
      this.selectors = {
        container: '#simple-bundles-io-options',
        backpackSelect: 'select[name*="Backpack"]',
        backpackOptions: 'select[name*="Backpack"] option',
        gallerySlides: '[id^="GalleryViewer-"] .product__media-item',
        viewerImage: '.product__media img',
        thumbnailItems: '[id^="Slider-Thumbnails-"] .thumbnail-list__item',
        thumbnailImage: 'button.thumbnail img'
      };
      this.colorAliases = {
        grey: ['grey', 'gray', 'blackenedpearl', 'blackened_pearl', 'blackened-pearl'],
        green: ['green'],
        tropicalmist: ['tropicalmist', 'tropical_mist', 'tropical-mist'],
        hikerkinddolomite: ['hikerkinddolomite', 'hikerkind_dolomite', 'hikerkind-dolomite', 'hikerkind']
      };
      this.productDataCache = new Map();
      this.observer = null;
    }

    connectedCallback() {
      const container = this.closest('product-info');
      if (container) {
        const spacing = this.dataset.dropdownSpacing || '24';
        container.style.setProperty('--td-bundle-dropdown-spacing', `${spacing}px`);
      }

      this.observer = new MutationObserver(() => this.apply());
      this.observer.observe(document.body, { childList: true, subtree: true });
      this.apply();
    }

    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }

      const container = this.closest('product-info');
      if (container) {
        container.style.removeProperty('--td-bundle-dropdown-spacing');
      }
    }

    apply() {
      const bundleContainer = document.querySelector(this.selectors.container);

      if (!bundleContainer) {
        return;
      }

      this.normalizeBackpackOptions(bundleContainer);
      this.bindBackpackSelect(bundleContainer);
    }

    normalizeBackpackOptions(bundleContainer) {
      Array.from(bundleContainer.querySelectorAll(this.selectors.backpackOptions)).forEach((option) => {
        if (!option.value || option.dataset.tdBundleNormalized === 'true') {
          return;
        }

        const text = option.innerText.trim();
        const parts = text.split(' - ');
        const variant = parts[1];

        if (!variant) {
          return;
        }

        const variantOptions = variant.split(' / ');
        option.innerText = variantOptions.slice(0, -1).join(' / ');
        option.dataset.tdBundleNormalized = 'true';
      });
    }

    bindBackpackSelect(bundleContainer) {
      const backpackSelect = bundleContainer.querySelector(this.selectors.backpackSelect);

      if (!backpackSelect) {
        return;
      }

      if (backpackSelect.dataset.tdBundleBound !== 'true') {
        backpackSelect.addEventListener('change', async (event) => {
          const selectElement = event.currentTarget;
          this.publishBackpackSelection(selectElement);
          await this.syncBackpackGallery(bundleContainer, selectElement);
        });
        backpackSelect.dataset.tdBundleBound = 'true';
      }

      this.syncBackpackGallery(bundleContainer, backpackSelect);
    }

    publishBackpackSelection(backpackSelect) {
      if (typeof publish !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') {
        return;
      }

      publish(PUB_SUB_EVENTS.bundleSelectionChange, {
        data: {
          title: this.extractBackpackTitle(backpackSelect)
        }
      });
    }

    extractBackpackTitle(backpackSelect) {
      if (!backpackSelect?.value) {
        return null;
      }

      return backpackSelect.value.split(' - ')[0].trim() || null;
    }

    async syncBackpackGallery(bundleContainer, backpackSelect) {
      if (!backpackSelect?.value) {
        return;
      }

      const colorKey = this.extractColorKey(backpackSelect.value);

      if (!colorKey) {
        return;
      }

      if (bundleContainer.dataset.tdBundleRenderedFor === colorKey) {
        return;
      }

      const mediaGroup = await this.findBackpackMediaGroup(colorKey);

      if (!mediaGroup.length) {
        return;
      }

      this.renderBackpackMediaGroup(mediaGroup);
      bundleContainer.dataset.tdBundleRenderedFor = colorKey;
    }

    extractColorKey(optionValue) {
      const variantParts = optionValue.split(' - ')[1]?.split(' / ');
      const color = variantParts?.[0];

      if (!color) {
        return null;
      }

      return this.normalizeValue(color);
    }

    normalizeValue(value) {
      return `${value || ''}`.toLowerCase().replace(/[^a-z0-9]/g, '');
    }

    async findBackpackMediaGroup(colorKey) {
      const bundleProductHandle = this.dataset.productHandle;
      const bundleProductData = await this.fetchProductData(bundleProductHandle);
      const bundleMediaGroup = this.filterMediaGroupByColor(bundleProductData?.media, colorKey);

      if (bundleMediaGroup.length) {
        return bundleMediaGroup;
      }

      const primaryProductHandle = this.dataset.primaryProductHandle;
      const primaryProductData = await this.fetchProductData(primaryProductHandle);

      return this.filterMediaGroupByColor(primaryProductData?.media, colorKey);
    }

    filterMediaGroupByColor(mediaItems, colorKey) {
      if (!Array.isArray(mediaItems)) {
        return [];
      }

      const aliases = this.colorAliases[colorKey] || [colorKey];

      return mediaItems
        .filter((mediaItem) => mediaItem?.media_type === 'image')
        .filter((mediaItem) => {
          const src = `${mediaItem.src || ''} ${mediaItem.preview_image?.src || ''}`.toLowerCase();

          return aliases.some((alias) => src.includes(alias));
        })
        .slice(0, 3);
    }

    async fetchProductData(productHandle) {
      if (!productHandle) {
        return null;
      }

      if (this.productDataCache.has(productHandle)) {
        return this.productDataCache.get(productHandle);
      }

      const response = await fetch(`/products/${productHandle}.js`);

      if (!response.ok) {
        return null;
      }

      const productData = await response.json();
      this.productDataCache.set(productHandle, productData);
      return productData;
    }

    renderBackpackMediaGroup(mediaGroup) {
      const thumbnailItems = Array.from(document.querySelectorAll(this.selectors.thumbnailItems));

      if (!thumbnailItems.length) {
        return;
      }

      const controlledThumbnailItems = thumbnailItems.slice(1);

      controlledThumbnailItems.forEach((thumbnailItem, index) => {
        const slide = this.findSlideForThumbnail(thumbnailItem);
        const mediaItem = mediaGroup[index] || null;

        if (mediaItem) {
          this.setGalleryItemVisibility(thumbnailItem, slide, true);
          this.updateGalleryItem(thumbnailItem, slide, mediaItem);
          return;
        }

        this.setGalleryItemVisibility(thumbnailItem, slide, false);
      });

      this.resetGalleryToBundleHero(thumbnailItems);
    }

    findSlideForThumbnail(thumbnailItem) {
      const targetMediaId = thumbnailItem?.dataset.target;

      if (!targetMediaId) {
        return null;
      }

      return Array.from(document.querySelectorAll(this.selectors.gallerySlides)).find((slide) => {
        return slide.dataset.mediaId === targetMediaId;
      });
    }

    setGalleryItemVisibility(thumbnailItem, slide, isVisible) {
      [thumbnailItem, slide].forEach((element) => {
        if (!element) {
          return;
        }

        element.hidden = !isVisible;

        if (isVisible) {
          element.removeAttribute('aria-hidden');
        } else {
          element.setAttribute('aria-hidden', 'true');
        }
      });
    }

    updateGalleryItem(thumbnailItem, slide, mediaItem) {
      const slideImage = slide?.querySelector(this.selectors.viewerImage);
      const thumbnailImage = thumbnailItem?.querySelector(this.selectors.thumbnailImage);

      if (slideImage) {
        this.applyImageData(slideImage, mediaItem);
        this.updateMediaContainer(slide, mediaItem);
      }

      if (thumbnailImage) {
        this.applyImageData(thumbnailImage, mediaItem);
      }
    }

    applyImageData(imageElement, mediaItem) {
      const imageSrc = mediaItem.preview_image?.src || mediaItem.src;

      if (!imageSrc) {
        return;
      }

      imageElement.setAttribute('src', imageSrc);
      imageElement.setAttribute('srcset', imageSrc);

      if (mediaItem.alt) {
        imageElement.setAttribute('alt', mediaItem.alt);
      }

      if (mediaItem.width) {
        imageElement.setAttribute('width', mediaItem.width);
      }

      if (mediaItem.height) {
        imageElement.setAttribute('height', mediaItem.height);
      }
    }

    updateMediaContainer(slide, mediaItem) {
      const mediaContainer = slide?.querySelector('.product-media-container');

      if (!mediaContainer || !mediaItem.width || !mediaItem.height) {
        return;
      }

      const ratio = `${mediaItem.width / mediaItem.height}`;
      mediaContainer.style.setProperty('--ratio', ratio);
      mediaContainer.style.setProperty('--preview-ratio', ratio);
    }

    resetGalleryToBundleHero(thumbnailItems) {
      const slides = Array.from(document.querySelectorAll(this.selectors.gallerySlides));

      slides.forEach((slide, index) => {
        slide.classList.toggle('is-active', index === 0);
      });

      thumbnailItems.forEach((thumbnailItem, index) => {
        const button = thumbnailItem.querySelector('button');

        if (!button) {
          return;
        }

        if (index === 0) {
          button.setAttribute('aria-current', 'true');
        } else {
          button.removeAttribute('aria-current');
        }
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
